<template>
  <div class="filter-box">
    <div class="filter-header">
      <div class="filter-type">
        <span>满足下列:</span>
        <RadioGroup v-model="filterType">
          <Radio label="全部条件"></Radio>
          <Radio label="任意条件"></Radio>
        </RadioGroup>
      </div>
      <div class="filter-toggle" :class="{'open': open}" @click.stop="toggleFitler">
        {{open ? '收起' : '展开'}}筛选<i class="yjh-icon icon-dropdown"></i>
      </div>
    </div>
    <div class="filter-content" v-show="open" ref="filterContent">
      <div class="filter-item" v-for="(item, index) in filterList" :key="index">
        <reSelect v-model="item.field" class="filter-sel reSelect" :label-in-value="true" style="width: 210px;" placeholder="请选择" @on-change="updateField(item, index)"
                  @on-open-change="onOpenChange($event, index)" loadingText="无结果"
        >
          <Input ref='mainSearch' slot="search" placeholder="" v-model="item.searchValue" @input="searcInput(item.searchValue, index)"></Input>
          <Option label="请选择" disabled style="color: #cccccc" v-if="item.options && item.options.length > 0"></Option>
          <Option v-for="(opt,index) in item.options" :value="opt.value" :key="index" :label="opt.display">{{ opt.display }}</Option>
        </reSelect>
        <!-- 公式 -->
        <template v-if="item.fieldType !== '3'">
          <Select v-model="item.aggr" class="filter-sel" style="width: 120px;" placeholder="请选择" @on-change="updateAggr(item, index)">
            <Option v-for="opt in aggrs" :value="opt.value" :key="opt.value">{{ opt.label }}</Option>
          </Select>
        </template>
        <template v-else>
          <Select v-model="item.aggr" class="filter-sel" style="width: 120px;" placeholder="请选择" @on-change="updateAggr(item, index)">
            <Option v-for="opt in timeAggrs" :value="opt.value" :key="opt.value">{{ opt.label }}</Option>
          </Select>
        </template>
        <!-- 取值 -->
        <template v-if="item.fieldType !== '3'">
          <Input v-model="item.value" placeholder="" style="width: 300px" :disabled="item.disabled" @click="openTimeDiag"/>
        </template>
        <template v-else>
          <DatePicker type="daterange" v-model="item.value" placeholder="" style="width: 300px" :disabled="item.disabled"></DatePicker>
        </template>
        <!-- 添加删除按钮 -->
        <div class="filter-addon">
          <i class="yjh-icon icon-del" v-if="index !== 0" @click.stop="delFilter(index)"></i>
          <i class="yjh-icon icon-add" @click.stop="addFilter(index)" v-if="index === filterList.length - 1"></i>
        </div>
        <div class="filter-btn yjh-btn" v-if="index === filterList.length - 1" @click.stop="confirmFilter">查询</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import { stampToStr } from '@/utils/common'
import _ from 'underscore'
import reSelect from '@/components/reSelect/select'
export default {
  components: { reSelect },
  data() {
    return {
      filterType: '全部条件',
      open: false,
      filterList: [{
        field: '', // 选项1的值
        fieldType: '', // 选项1的类型
        aggr: '', // 选项2值
        disabled: false, // 自己增加状态标记
        value: '',
        searchValue: '',
        options: []
      }]
    }
  },
  props: {
    fields: {
      type: Array,
      require: true
    }
  },
  computed: {
    ...mapState({
      timeAggrs: state => state.globalConst.timeAggrs,
      aggrs: state => state.globalConst.aggrs
    })
  },
  created() {
    this.filterList.map(item => {
      item.searchValue = 'meiyou'
      item.options = this.fields
    })
  },
  methods: {
    init() {
      this.filterType = '全部条件'
      this.filterList = [{
        field: '',
        fieldType: '',
        aggr: '',
        disabled: false,
        value: ''
      }]
    },
    getFields() {
      // statndSearchOptions({ servicetype: this.$route.params.type })
      //   .then(res => {
      //     if (res.code === 0) {
      //       this.fields = res.result.select1
      //     } else {
      //       this.$Message.info('获取下拉数据失败')
      //       this.fields = []
      //     }
      //   })
    },
    // 切换/显示
    toggleFitler() {
      this.open = !this.open
      this.$emit('toggleFilterShow')
    },
    // 增加一条筛选
    addFilter(Index) {
      const lastFilter = this.filterList[Index]
      if (lastFilter.field === '' || lastFilter.aggr === '' || (!lastFilter.disabled && lastFilter.value === '')) {
        this.$Message.info('请确保所有筛选项不为空')
        return
      }
      if (this.filterList.length >= 20) {
        this.$Message.info('筛选项最多有20条')
        return
      }
      this.filterList.push({
        field: '',
        fieldType: '',
        aggr: '',
        disabled: false,
        value: '',
        searchValue: '',
        options: this.fields
      })
      this.$nextTick(() => {
        this.$refs.filterContent.scrollTop = 1000
      })
    },
    // 删除一条筛选
    delFilter(i) {
      this.filterList.splice(i, 1)
    },
    // 选择字段 并改变fieldType的值
    updateField(item, index) {
      this.$set(this.filterList[index], 'field', item.value)
      this.$set(this.filterList[index], 'fieldType', item.type)
      this.$set(this.filterList[index], 'aggr', '')
      this.$set(this.filterList[index], 'value', '')
      // 校验
      if (this.filterType === '全部条件' && this.filterList.length) {
        for (var i = 0; i < this.filterList.length; i++) {
          if (i !== index && (this.filterList[i].field === item.value)) {
            this.$Message.info('筛选条件重复')
            return
          }
        }
      }
    },
    onOpenChange(flag, index) {
      if (flag) {
        this.filterList[index].searchValue = ''
        this.filterList[index].options = this.fields
        this.$nextTick(() => {
          this.$refs.mainSearch[index].focus()
        })
      }
    },
    // 选择公式
    updateAggr(item, index) {
      if (item.type === '3') { // 先分开处理 后面可能不需要分开处理
        if (item.aggr === '50' || item.aggr === '60') {
          this.$set(this.filterList[index], 'disabled', true)
          this.$set(this.filterList[index], 'value', '')
        } else {
          this.$set(this.filterList[index], 'disabled', false)
        }
      } else {
        if (item.aggr === '50' || item.aggr === '60') {
          this.$set(this.filterList[index], 'disabled', true)
          this.$set(this.filterList[index], 'value', '')
        } else {
          this.$set(this.filterList[index], 'disabled', false)
        }
      }
    },
    // 打开时间弹框
    openTimeDiag() {
    },
    // 查询
    confirmFilter() {
      if (this.filterType === '全部条件') { // 全部条件才需要判断重复
        if (!this.checkChongFu()) {
          this.$Message.info('筛选条件重复')
          return
        }
      }
      if (!this.checkNoEmpty()) {
        this.$Message.info('请确保所有筛选项不为空')
        return
      }
      this.emit()
      // 判断重复
      // 判断非空
    },
    checkChongFu() {
      const obj = {}
      for (var i = 0; i < this.filterList.length; i++) {
        if (this.filterList[i].field in obj) {
          return false
        } else {
          obj[this.filterList[i].field] = '已经存在'
        }
      }
      return true
    },
    checkNoEmpty() {
      for (var i = 0; i < this.filterList.length; i++) {
        if (this.filterList[i].field === '' || this.filterList[i].field === undefined) {
          return false
        }
        if (this.filterList[i].aggr === '' || this.filterList[i].aggr === undefined) {
          return false
        }
        if (!this.filterList[i].disabled) {
          if (this.filterList[i].fieldType === '3') {
            if (this.filterList[i].value[0] === '' || this.filterList[i].value[1] === '') {
              return false
            }
          } else {
            if (this.filterList[i].value === '') {
              return false
            }
          }
        }
      }
      return true
    },
    emit: _.debounce(function() {
      this.$emit('filterConSearch', this.filterList)
    }, 500, true),
    searcInput: _.debounce(function(value, index) {
      const arr = this.fields.filter(item => {
        return item.display.indexOf(value) !== -1
      })
      this.filterList[index].options = arr
    }, 500, false)
  }
}
</script>

<style lang="scss" scoped>
  .filter-box {
    background: #F8F9FA;
    border: 1px solid #E9EEF6;
    .reSelect {
      .ivu-select-dropdown {
        overflow: inherit;
        max-height: 285px;
        .ivu-input-wrapper {
          padding: 0 5px;
          .ivu-input {
            border: 1px solid #ccc;
          }
        }
        .yjh-scroll {
          max-height: 250px;
          overflow: auto;
          .ivu-select-not-found {
            padding-left: 10px;
            text-align: left;
            color: #5D6F80;
          }
        }
      }
    }
  }
  .filter-header {
    height: 56px;
    padding: 20px 20px 18px 20px;
    position: relative;
    .filter-toggle {
      cursor: pointer;
      position: absolute;
      right: 24px;
      top: 20px;
    }
  }
  .filter-type {
    & > span {
      margin-right: 10px;
      line-height: 16px;
    }
  }
  .filter-content {
    padding: 0 20px 20px;
    max-height: 176px;
    overflow: auto;
  }
  .filter-item + .filter-item {
    margin-top: 20px;
  }
  .filter-sel {
    margin-right: 20px;
  }
  .filter-addon {
    display: inline-block;
    width: 76px;
    height: 28px;
    line-height: 28px;
    padding-left: 20px;
    margin-right: 34px;
    .yjh-icon + .yjh-icon {
      margin-left: 12px;
    }
  }
</style>
